module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/file-done-1291c3a46b2d230e60989d94fe74aec5.svg";